// extracted by mini-css-extract-plugin
export var readonly = "_ft-1";
export var star = "_ft-0";